import {NgModule} from "@angular/core";
import {FlipperComponent} from "./flipper.component";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";

@NgModule({
  declarations: [
    FlipperComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    FlipperComponent
  ],
  providers: []

})

export class FlipperModule {}



// WEBPACK FOOTER //
// ./src/app/flipper/flipper.module.ts